/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from "@react-navigation/native";
import * as Linking from "expo-linking";

import { RootStackParamList } from "../types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL("/")],
  config: {
    screens: {
      Root: {
        screens: {
          Dashboard: {
            screens: {
              DashboardScreen: "dashboard",
            },
          },
          DocRequest: {
            screens: {
              DocRequestScreen: "Document Requests",
            },
          },
          Evidence: {
            screens: {
              EvidenceScreen: "Evidence",
            },
          },
          ComplianceCalendar: {
            screens: {
              ComplianceCalendarScreen: "Compliance Calendar",
            },
          },
          Training: {
            screens: {
              TrainingScreen: "Training Courses",
            },
          },
          Users: {
            screens: {
              UsersScreen: "Users Screen",
            },
          },
          Settings: {
            screens: {
              SettngsScreen: "Settings Screen",
            },
          }, // TabOne: {
          //   screens: {
          //     TabOneScreen: "one",
          //   },
          // },
          // TabTwo: {
          //   screens: {
          //     TabTwoScreen: "two",
          //   },
          // },
        },
      },
      Modal: "modal",
      NotFound: "*",
    },
  },
};

export default linking;
